(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
  function loadMoreResults(button) {
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;

    button.disabled = true;
    button.textContent = 'Loading...';

    fetch(nextUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('#search-results .product-card-wrapper');
        const newLoadMore = doc.querySelector('.load-more');

        const searchResults = document.getElementById('search-results');
        newProducts.forEach(function (product) {
          searchResults.appendChild(product);
        });

        const currentLoadMore = document.querySelector('.load-more');
        if (newLoadMore) {
          currentLoadMore.innerHTML = newLoadMore.innerHTML;
        } else if (currentLoadMore) {
          currentLoadMore.remove();
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Load More Products';
      });
  }

  window.loadMoreResults = loadMoreResults;

  } catch(e) { console.error(e); }
})();
})();
